import { z } from 'zod';

import { WorkoutPlanId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateForbearanceEarlyTerminationNoticeSideEffectContext = BaseLoanIdSideEffect.extend({
  workoutPlanId: zodBrandedUuid<WorkoutPlanId>(),
});

export const GenerateForbearanceEarlyTerminationNoticeSideEffect =
  GenerateForbearanceEarlyTerminationNoticeSideEffectContext.extend({
    type: z.literal('generateForbearanceEarlyTerminationNotice'),
  });
export type GenerateForbearanceEarlyTerminationNoticeSideEffect = z.infer<
  typeof GenerateForbearanceEarlyTerminationNoticeSideEffect
>;
